<template>
  <svg width="115" height="100" viewBox="0 0 115 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M45.0653 58.3633L46.4657 29.3494C46.4916 28.813 46.7164 28.3054 47.0962 27.9258L49.3952 25.6279C49.9963 25.027 51.0238 25.4528 51.0238 26.3027C51.0238 26.6543 51.2172 26.9774 51.527 27.1435L53.5544 28.2307C54.7951 28.896 55.0779 30.5515 54.1284 31.591L52.8236 33.0194C52.6548 33.2042 52.5554 33.4419 52.5425 33.6919L51.2014 59.5724C51.1191 61.1606 49.4067 62.1183 48.0104 61.3571L46.1888 60.3639C45.4618 59.9676 45.0254 59.1904 45.0653 58.3633Z"
      fill="var(--sf-illustration-primary-background-secondary)"
    />
    <path
      d="M92.2624 47.6048L90.2 46.584C88.7575 45.8699 87.0765 46.9595 87.1392 48.5678L88.519 83.9242C88.5642 85.0835 89.5303 86.0384 90.6653 85.7983C93.6771 85.1614 95 83.1134 95 81.0654L93.4617 49.4357C93.4236 48.6531 92.9647 47.9524 92.2624 47.6048Z"
      fill="var(--sf-illustration-primary-background-secondary)"
    />
    <path
      d="M52.9386 19.6707L66.7274 14.6328C67.8338 14.2286 69.0573 14.2937 70.1146 14.8131L108.432 33.6364C109.047 33.9572 109.001 34.8517 108.357 35.108L94.4321 40.6454C93.8645 40.8712 93.2278 40.846 92.6798 40.5762L52.8686 20.9732C52.4385 20.7613 52.3381 20.1925 52.6698 19.8463C52.7448 19.768 52.8367 19.7079 52.9386 19.6707Z"
      fill="var(--sf-illustration-primary-background-primary)"
    />
    <path
      d="M93.7143 48.3636L109.605 42.3465C110.445 42.0285 111 41.2243 111 40.3264V36.5826C111 36.2589 110.927 35.9394 110.787 35.6477L110.214 34.4545M93.7143 48.3636L90.5714 46.7879L87.4286 45.2121M93.7143 48.3636L95.2857 81.0909C95.2857 83.5455 93.4 86 89 86M51.2857 63.0909L46.2297 60.4584C45.4804 60.0683 45.0273 59.2772 45.07 58.4335L46.528 29.5866C46.5559 29.0348 46.7942 28.5146 47.1938 28.1332L51.2857 24.2273M51.2857 63.0909L69.5417 55.7654C70.3245 55.4513 70.8528 54.7102 70.8946 53.8677L71.7143 37.3333M51.2857 63.0909L52.8696 33.8991C52.8836 33.6416 52.9893 33.3975 53.1676 33.2111L56.4783 29.75M71.7143 37.3333L56.4783 29.75M71.7143 37.3333C73.666 38.9799 76.754 43.1542 74.6276 47.4217C74.3211 48.0369 74.207 48.742 74.4162 49.3968C76.4318 55.7041 78.9096 68.1862 75.1214 75.6851C74.9548 76.0151 74.8571 76.3759 74.8571 76.7456V80.1236C74.8571 80.739 75.1136 81.33 75.6072 81.6976C77.9222 83.4215 82.8627 86 89 86M71.7143 37.3333L87.4286 45.2121M56.4783 29.75L52.4612 27.6928C51.7396 27.3233 51.2857 26.5809 51.2857 25.7703V24.2273M89 86L87.4286 45.2121M52.0714 20.5454L52.5099 20.0889C52.7384 19.851 53.0183 19.6685 53.3282 19.5556L66.8431 14.6299C67.9473 14.2275 69.1679 14.2923 70.2233 14.8095L108.643 33.6364L110.214 34.4545M52.0714 20.5454L51.8878 20.7367C51.5015 21.139 51.2857 21.6751 51.2857 22.2328V24.2273M52.0714 20.5454L92.8552 40.578C93.4023 40.8467 94.0374 40.8718 94.604 40.6471L110.214 34.4545"
      stroke="var(--sf-illustration-primary-border)"
      stroke-width="2.16"
      stroke-linejoin="round"
    />
    <rect
      y="52.9775"
      width="30"
      height="18"
      rx="8"
      transform="rotate(-75 0 52.9775)"
      stroke="var(--sf-illustration-primary-border)"
      stroke-width="2"
    />
    <circle
      cx="14.1278"
      cy="35.0225"
      r="6"
      transform="rotate(-75 14.1278 35.0225)"
      fill="var(--sf-illustration-primary-background-primary)"
      stroke="var(--sf-illustration-primary-background-secondary)"
      stroke-width="2"
    />
    <circle cx="14.1282" cy="35.0223" r="2" transform="rotate(-75 14.1282 35.0223)" fill="var(--sf-illustration-primary-border)" />
    <path
      d="M28 42.8179H38M38 42.8179L35 39.8179M38 42.8179L35 45.8179"
      stroke="var(--sf-illustration-primary-border)"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
